import { useEffect, useState } from 'react';
import { getGoogleTranslateTargetLangFromCookie } from '../utils/googleTranslate';

const STORAGE_KEY = 'ulcaapp_gt_lang';

function readStoredLang() {
  try {
    return (localStorage.getItem(STORAGE_KEY) || '').toString();
  } catch (_) {
    return '';
  }
}

export function useGoogleTranslateLang() {
  const [lang, setLang] = useState(() => readStoredLang() || getGoogleTranslateTargetLangFromCookie());

  useEffect(() => {
    const onEvent = (e) => {
      const next = (e?.detail?.lang || '').toString();
      if (next !== lang) setLang(next);
    };
    window.addEventListener('ulcaapp:gtLangChange', onEvent);
    return () => window.removeEventListener('ulcaapp:gtLangChange', onEvent);
  }, [lang]);

  // Fallback sync (covers cases where the cookie changes without our Navbar dispatching an event)
  useEffect(() => {
    const timer = setInterval(() => {
      const cookieLang = getGoogleTranslateTargetLangFromCookie();
      if (cookieLang && cookieLang !== lang) {
        setLang(cookieLang);
      }
    }, 1500);
    return () => clearInterval(timer);
  }, [lang]);

  return lang;
}


